export enum RequestMethods {
    GET = 'get',
    PUT = 'put',
    POST = 'post',
    DELETE = 'delete'
}